module.exports = __webpack_public_path__ + "static/media/contact3.600d3649.png";